import { toast } from "$global-providers/toast-provider";
import React from "react";
import { defineMessage, useIntl } from "react-intl";
import useFetchPrintableInvoice from "../hooks/useFetchPrintableInvoice";
import LegacyPrintableInvoice from "./PrintableInvoice/PrintableInvoice";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.getInvoice.error.msg",
  defaultMessage: "Failed to fetch this invoice",
});

interface PrintableInvoiceProps {
  invoiceId: string;
  payerNames: Array<string>;
  onAfterPrint: () => void;
}

// shims legacy invoicing printing component to fetch full invoice details
export const PrintableInvoice = ({
  invoiceId,
  payerNames,
  onAfterPrint,
}: PrintableInvoiceProps): React.ReactElement => {
  const { formatMessage } = useIntl();

  const { data, loading, error } = useFetchPrintableInvoice(invoiceId, {
    fetchPolicy: "network-only",
  });
  if (loading) {
    return null;
  }
  if (error) {
    toast.error(formatMessage(ERROR_MESSAGE));
    onAfterPrint();
    return null;
  }
  return (
    <LegacyPrintableInvoice
      invoice={data.invoice}
      invoicesToPrint={payerNames}
      onAfterPrint={onAfterPrint}
    />
  );
};
